export const SET_USER = "SET_USER";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_FAVORITE = "ADD_TO_FAVORITE";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_FROM_FAVORITE = "REMOVE_FROM_FAVORITE";
export const REMOVE_ALL_ITEMS = "REMOVE_ALL_ITEMS";
export const ADJUST_QTY = "ADJUST_QTY ";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";